import React from "react";
import Layout from "../../layouts/Layout";
import IconIphone from "../../components/icons/icon-iphone";
import IconRenew from "../../components/icons/icon-renew";
import BButton from "../../components/general/BButton";

import moment from "moment";
import { Label } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
const RenewMemberSuccess = (props) => {
  let navigate = useNavigate();
  return (
    <Layout>
      <div className="container-renew-success">
          <h1>แจ้งชำระค่าสมาชิกสำเร็จ</h1>
          <div className="center"> 
            <div className="succes-icon">
              <div>
                <svg width="113" height="113" viewBox="0 0 113 113" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M113 56.5C113 87.7042 87.7042 113 56.5 113C25.2958 113 0 87.7042 0 56.5C0 25.2958 25.2958 0 56.5 0C87.7042 0 113 25.2958 113 56.5ZM49.9647 86.4163L91.884 44.4969C93.3075 43.0735 93.3075 40.7654 91.884 39.342L86.7291 34.1871C85.3057 32.7634 82.9976 32.7634 81.5739 34.1871L47.3871 68.3737L31.4261 52.4126C30.0026 50.9892 27.6946 50.9892 26.2709 52.4126L21.116 57.5676C19.6925 58.991 19.6925 61.2991 21.116 62.7225L44.8095 86.4161C46.2332 87.8397 48.541 87.8397 49.9647 86.4163Z" fill="url(#paint0_linear_108_1918)"/>
                  <defs>
                  <linearGradient id="paint0_linear_108_1918" x1="56.5" y1="0" x2="56.5" y2="113" gradientUnits="userSpaceOnUse">
                  <stop stop-color="#001F5C"/>
                  <stop offset="1" stop-color="#A8CEEA"/>
                  </linearGradient>
                  </defs>
                </svg>
              </div>
            </div>
          </div>
          <div className="succes-detail">
            <h4>กำลังตรวจสอบข้อมูล</h4>
            <h5>สถานะจะถูกเปลี่ยนเมื่อทางทีมงานมีการอนุมัติการชำระ</h5>
          </div>
          <BButton onClick={() => navigate(`/profile`)} setStyle="succes-page block">ดูข้อมูลสมาชิก</BButton>
      </div>
    </Layout>
  );
}

export default RenewMemberSuccess;
